import { authServiceAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { userSettingsAPIUrls } from '../data';

type Response = {
  success: boolean;
  message: string;
};

export const deleteImage = withLogger(async (payload): Promise<Response> => {
  const url = userSettingsAPIUrls.image.delete;

  const { data } = await authServiceAxiosClient.post<Response>(url, payload);
  return data;
});
